import React, { useState } from "react";
import './styles.scss';
import CheckboxOn from "../../../../../assets/images/CheckboxOn.svg";
import CheckboxOff from "../../../../../assets/images/CheckboxOff.svg";
import BrandImage from "../../../../../assets/images/brandImage.svg";


function Popup(props) {
    console.log("propss", props.modal);
    const [city, setcity] = React.useState("");
    const [area, setArea] = React.useState("");
    const [data, setData] = React.useState([
        { id: "1" }, { id: "2" }, { id: "3" }, { id: "4" }, { id: "5" }, { id: "6" }, { id: "7" }, { id: "8" }, { id: "9" },
    ]);
    const [selectedPartner, setSelectedPartner] = useState([]);
    const handleRadio = (id, val) => {
        const idToRemove = id;
        if (selectedPartner.includes(val)) {
            const filteredPeople = selectedPartner.filter((item) => item.id !== idToRemove);
            setSelectedPartner(filteredPeople);
        }
        else {
            setSelectedPartner([...selectedPartner, val])
        }
    }
    return (
        <>
            <div className="parentContainer-diagnostic-partner-selected">
                <div className="top-container">
                    <img src={BrandImage} alt="BrandImage" />
                </div>
                <div className="sub-cont-out">
                    <div className="sub-cont">
                        <span>Please find the different addresses of our Lab partner in Lagos below</span>
                    </div>
                </div>
                <div className="selected-container-out">
                    {
                        data.map((val, ind) => {
                            return (

                                <div className="selected-cont">
                                    <div className="top-cont">Ifako</div>
                                    <div className="bottom-cont"> 2 Belamodu Street, Mercy Estate</div>
                                </div>

                            )
                        })
                    }
                </div>
                {/* <div className="footer-text-out">
                    <div className="footer-text">See complete list of branches nationwide</div>
                </div> */}
            </div>
        </>
    );
}

export default Popup;
